import React from "react";
import { SearchableDashboard } from "../../../constants";

interface Props {
  dashboard: SearchableDashboard;
}

export const EngagementCard = (props: Props) => {
  const { dashboard } = props;
  const hasEngagementUrl = Boolean(dashboard.engagement_url);

  // Decision #6: static admin-configured Mixpanel link-out, opened in a new tab - not a live
  // embed, and not internal app navigation. GET /dashboards now returns a real `engagement_url`
  // column, currently null for every dashboard since no admin UI exists yet to populate it (per
  // decision #2) - this used to fall back to a mocked placeholder Mixpanel link so the button
  // "did something" in the meantime, but that placeholder never went anywhere real for an actual
  // user. Disabled instead until a dashboard has a real, admin-set link.
  const handleSeeAnalytics = () => {
    if (!dashboard.engagement_url) return;
    window.open(dashboard.engagement_url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="engagement_card" data-test-id={`engagement-card-${dashboard.key}`}>
      <h4 className="engagement_card_name">{dashboard.name}</h4>
      <button
        className="engagement_card_link"
        onClick={handleSeeAnalytics}
        disabled={!hasEngagementUrl}
        title={hasEngagementUrl ? undefined : "No analytics link has been set up for this dashboard yet"}
        data-test-id={`engagement-card-link-${dashboard.key}`}
      >
        See full dashboard analytics
      </button>
    </div>
  );
};
